import React from "react";
import { FiXSquare } from "react-icons/fi";

import { CartProductEntity } from "../../../../types/cart_response_type";
import { ChangeQuantityWidget } from "../../../atoms";
import { useLocaleContext } from "../../../context";
import { useCart, useWishlist } from "../../../hooks";
import { PriceDetails } from "../../../molecules";
import { HorizontalCard } from "../../../organisms";

export const CartItem = ({
  product,
  defaultCurrency,
}: {
  product: CartProductEntity;
  defaultCurrency?: "INR" | "USD";
}) => {
  const { currency } = useLocaleContext();
  const { deleteFromCartHandler, changeCartQuantityHandler, cartDataFetching } =
    useCart(product.id);
  const { addToWishlistHandler, wishlistDataFetching } = useWishlist(
    product.id
  );

  const handleAddToWishlist = async () => {
    await deleteFromCartHandler(product.variantId);
    await addToWishlistHandler();
  };

  const activePrice = product.price.find(
    p => p.code === (defaultCurrency ? defaultCurrency : currency)
  );
  return (
    <div
      key={product.variantId}
      className="rounded"
      style={
        product.isAvailable ? {} : { border: `1px solid rgb(248 113 113)` }
      }>
      <HorizontalCard
        loading={cartDataFetching || wishlistDataFetching}
        title={product.title}
        subtitle={
          <div className="flex flex-col gap-1">
            <p className="text-[10px] sm:text-xs text-gray-500">
              Selected size is{" "}
              <span className="text-gray-900 font-bold">
                {product.variants[0]?.size}
              </span>
            </p>
            {/* {product.variants[0].shippingProfile?.id === 2 ? (
              <p className="text-xs text-gray-500">Store pickup available</p>
            ) : null} */}
          </div>
        }
        image={product.images[0].url}
        redirectLink={`/products/${product.productHandle}`}
        actionButtons={[
          {
            label: "Wishlist",
            onClick: handleAddToWishlist,
          },
          {
            label: "Delete",
            onClick: () => deleteFromCartHandler(product.variantId),
            color: "error",
          },
        ]}>
        <div className="flex flex-row lg:flex-col gap-4 items-center justify-between lg:items-start">
          {activePrice && <PriceDetails price={activePrice} />}
          <ChangeQuantityWidget
            quantity={product.quantity}
            changeQuantity={(payload: 1 | -1) =>
              changeCartQuantityHandler({
                variantId: product.variantId,
                quantity: product.quantity + payload,
              })
            }
          />
        </div>
      </HorizontalCard>
      {!product.isAvailable && (
        <div className="p-2 bg-red-50">
          <div className="flex gap-2 items-center">
            <div className="text-2xl">
              <FiXSquare className="text-red-400" />
            </div>
            <p className="text-sm text-red-500">{product.errorMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
};
